/*
* @Author: LiuMouLiang
* @class:  页面内静态枚举
*/
import {
    SIGN_IDENTITY_URLs,
} from '_libs/host';
export const RESOUCEKEY = 'pc'; //项目标识 //数据源类型 app=APP端 | pc=PC端
export const PROJECTTAG = 'TX'; //项目标识
// 添加缓存前缀
const setEnv_SESSIONKEY = function(key){
    return `${PROJECTTAG}_${key}`;
};

export const productActivityTypeJson = {
    '0': { label: '累计件数', value: 0, sort: 1  },
    '1': { label: '累计保费', value: 1, sort: 2 },
    '2': { label: '新人首单', value: 2, sort: 0, },
    '3': { label: '阶梯奖励', value: 3 },
    '4': { label: '预约奖励', value: 4 },
    '-1': { label: '限时奖励', value: -1, hide: '单品单单' }, // === missionSimpleInfos
};

export const payOverTimeTypeJson = {
    '2': { label: '生效期前关单', value: 2 },
    '1': { label: '隔天关单', value: 1}, // 凌晨12点后清除
};

//代理人风控初始信息
export const RISK_ANGET_INITINFO = {
    '1': {
        status: '1',
        name: '加入微易',
        html: '<span class="row">扫码前往保险师APP</span><span class="row">签约享<span class="red">高额佣金</span></span>',
        QRcodeUrl: SIGN_IDENTITY_URLs.QRCODE,
        appUrl: SIGN_IDENTITY_URLs.APP,
        passUrl: SIGN_IDENTITY_URLs.PASS,
    },
    '2': {
        status: '2',
        name: '实名认证',
        html: '<span class="row">扫码前往保险师APP</span><span class="row red">完成实名认证</span>',
        QRcodeUrl: 'https://res.wyins.net/autoUpload/common/2bc7cdfa-8ef3-4707-8d59-45d6ccb44a9d.png',
        appUrl: 'Bxs://user/certify', //app内跳转
        passUrl: 'https://j.winbaoxian.com/user/certify', //穿越链接
    }
}

//代理人风控初始状态
export const RISK_ANGET_INITSTATE = {
    '1': {
        text: '加入微易或完成实名认证，解锁投保资格',
        html: '您可以通过<span class="red">以下任一方式</span>解锁投保资格，继续投保',
        value: ['1', '2']
    },
    '2': {
        text: '请先完成实名认证，之后方可进行投保',
        html: `<span class="row">扫码前往保险师APP，</span><span class="row"><span class="red">完成实名认证</span>后</span><span class="row">方可继续投保</span>`,
        value: ['2']
    },
};

export const SESSIONKEY_PAGERECORD = 'PAGERECORDIDTOKEN'; //缓存-页面录制ID
export const staticApplyInvoiceTypeTipText = '请注意：若本企业是小规模纳税人，不支持申请专票'; //申请发票-发票类型-提示文案



// WEBPACK FOOTER //
// ./src/libs/static.js